module.exports = __webpack_public_path__ + "img/double-long-arrow.db60f083.svg";